module.exports = {"school-name":"College of Western Idaho","logo":"/sites/cwi/cwi_header_logo.png","logout-color":"#00BB31","logout-font-color":"#000000","header-color":"#004853","footer-color":"#004853","footer-info":"© College of Western Idaho | The Write Class™ | © Boise State University","help-button-color":"#02CB35","help-button-font-color":"#000000"}


//////////////////
// WEBPACK FOOTER
// ./sites/cwi/site-config.json
// module id = 116
// module chunks = 12